/* eslint-disable react/prop-types */
import cx from 'classnames';
import { Icon } from '@bwoty-web/ui-kit';
import { UI_CHEVRON_RIGHT } from '@bwoty-web/ui-kit/icons';

import UspList from '../../components/uspList';
import QuickFacts from '../../components/quickFacts';
import EasyTravel from '../../components/easyTravel';
import PartialPayment from '../../components/partialPayment';
import InspirationalImages from '../../components/inspirationalImages';
import Nugget from '../../components/nugget';
import MapNugget from '../../components/mapNugget';
import GuestReviewNuggetList from '../../components/guestReviewNuggetList';
import ClimateWeatherNuggetList from '../../components/climateWeatherNuggetList';
import { sectionKeys } from '../helper';
import Paragraph from '../../../../common/paragraph';
import KeySellingPointList from '../../../../common/keySellingPointList';
import './overview.scss';

const Overview = ({
  hotelContent,
  labels,
  siteSettings,
  isActive,
  isConceptHotel,
  changeSection,
  sectionHeadingDict,
  departureMonth,
  isGlobe,
}) => {
  const { facts, categories, productInfo, texts, hasMovies, imageList } =
    hotelContent;
  const isCharter = productInfo?.isCharter;

  const guestReviews =
    texts?.accommodationAndReviews[0]?.reviews ||
    texts?.accommodationAndReviews[1]?.reviews;

  const hasReviews = guestReviews?.length > 0;

  const aboutText = {
    heading: !isGlobe
      ? texts?.aboutHotel?.heading || labels.descriptionHeading
      : '',
    expanded: texts?.aboutHotel?.content || '',
  };

  const Links = (
    <div className="gw-hotel-info-overview__links">
      {productInfo.canOfferEasyTravel && (
        <EasyTravel
          logo={labels.easyTravelLogo}
          changeSection={changeSection}
        />
      )}
      {labels.partialPaymentLink && <PartialPayment labels={labels} />}
    </div>
  );

  return (
    <div
      id={sectionKeys.overview}
      role="tabpanel"
      aria-labelledby={`tab-${sectionKeys.overview}`}
      className={cx('gw-hotel-info-overview', {
        'gw-hotel-info-overview--hidden': !isActive,
        'gw-hotel-info-overview--no-reviews': !hasReviews,
        'gw-hotel-info-overview--dp': !isCharter,
      })}
    >
      <div className="gw-hotel-info-overview__description">
        <Paragraph paragraph={aboutText} isExpanded />
        {(!isConceptHotel || isGlobe) && (
          <button
            className="gw-hotel-info-overview__description-link"
            type="button"
            onClick={() => changeSection(sectionKeys.description)}
          >
            {labels?.showMoreText}
            {`  `}
            {!isGlobe && (
              <Icon path={UI_CHEVRON_RIGHT} size="xxs" sizeMobile="xxs" />
            )}
          </button>
        )}
      </div>
      {facts.usps && (!isConceptHotel || isGlobe) && (
        <KeySellingPointList
          className="gw-hotel-info-overview__description-usps"
          ksps={facts.usps}
          limit={0}
        />
      )}
      <div className="gw-hotel-info-overview__quick-info">
        <QuickFacts facts={facts.all} labels={labels} />
        <div className="gw-hotel-info-overview__quick-info-links">
          {!isConceptHotel && !isGlobe && Links}
        </div>
      </div>
      <div className="gw-hotel-info-overview__images">
        <InspirationalImages
          isConceptHotel={isConceptHotel}
          images={imageList?.slice(1)}
          imagesCount={imageList?.length}
          labels={labels}
          hasMovies={hasMovies}
          id={siteSettings.wvId}
        />
      </div>
      {!!facts.usps && isConceptHotel && !isGlobe && (
        <div className="gw-hotel-info-overview__usps">
          <UspList
            usps={facts.usps}
            concept={categories?.main}
            isConceptHotel={isConceptHotel}
            labels={labels}
          />
        </div>
      )}
      {!!isCharter && !isGlobe && (
        <Nugget
          className="gw-hotel-info-overview__map-nugget"
          heading={sectionHeadingDict[sectionKeys.map]}
          onClick={() => changeSection(sectionKeys.map)}
        >
          <MapNugget
            labels={labels}
            imageDomain={siteSettings.imageDomain}
          />
        </Nugget>
      )}
      {hasReviews && isCharter && !isGlobe && (
        <Nugget
          className="gw-hotel-info-overview__rating-nugget"
          heading={sectionHeadingDict[sectionKeys.rating]}
          onClick={() => changeSection(`${sectionKeys.rating}:0`)}
        >
          <GuestReviewNuggetList
            reviews={guestReviews}
            labels={labels}
          />
        </Nugget>
      )}
      {!isGlobe && (
        <Nugget
          className="gw-hotel-info-overview__weather-nugget"
          heading={sectionHeadingDict[sectionKeys.weather]}
          onClick={() => changeSection(sectionKeys.weather)}
        >
          <ClimateWeatherNuggetList
            climate={hotelContent.climate}
            siteId={siteSettings.siteId}
            currentMonth={departureMonth}
            multiMonth={!isConceptHotel}
          />
        </Nugget>
      )}
      {!isGlobe && (
        <div className="gw-hotel-info-overview__bottom-links">{Links}</div>
      )}
    </div>
  );
};

export default Overview;
